// Fecha para los PDF de documentos (recetas, órdenes de laboratorio/gabinete):
// SIEMPRE la fecha en que se REGISTRÓ el documento, no la de hoy.
// Toma la parte de fecha del ISO (sin problemas de zona horaria) y la devuelve DD/MM/YYYY.
export function formatFechaDoc(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso ?? ""));
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  return new Date().toLocaleDateString("en-GB"); // último recurso: hoy
}
